import { handleAddToSlip } from './handleAddToSlip';
import { BannerType, BLANK } from '../../consts';
export const getOnClick = ({ banner, index, navigate }) => {
    const { addToSlip, promotion, redirection, type, title } = banner;
    if (type === BannerType.ADD_TO_SLIP && addToSlip) {
        return () => handleAddToSlip({ addToSlip, index, title });
    }
    else if (type === BannerType.REDIRECTION && redirection && redirection.target !== BLANK) {
        return () => navigate(redirection.url, {});
    }
    else if (type === BannerType.PROMOTION && promotion) {
        return () => navigate(promotion.basecampSlug, {});
    }
    return undefined;
};
